import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import { closeFormModal, openViewModal } from "../../store/reducers/frases/frases.reducer";
import { useEffect, useState } from "react";
import {
  createFraseThunk,
  updateFraseThunk,
  getFrasesThunk,
  getFraseByIdThunk,
} from "../../store/reducers/frases/frases.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import Select2 from "../UI/Select2";
import { getTalentosSelectoresService } from "../../services/frases/frases.service";
import { toast } from 'react-toastify';

const FraseFormModal = () => {
  const dispatch = useDispatch();
  const {
    formModalOpen,
    formMode,
    selectedFrase,
    formLoading,
    formError,
    page,
    search,
    talentoFilter,
    isRandomFilter,
  } = useSelector((state) => state.frases);

  const [formData, setFormData] = useState({
    frase: "",
    talento_global: null,
    is_random: false,
  });

  useEffect(() => {
    if (formMode === "edit" && selectedFrase) {
      setFormData({
        frase: selectedFrase.frase || "",
        talento_global: selectedFrase.talento_global || null,
        is_random: selectedFrase.is_random || false,
      });
    } else {
      setFormData({
        frase: "",
        talento_global: null,
        is_random: false,
      });
    }
  }, [formMode, selectedFrase, formModalOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const fetchTalentos = async (searchTerm) => {
    const response = await getTalentosSelectoresService(searchTerm);
    return response.map((item) => ({
      id: item.id,
      label: item.label,
    }));
  };

  const handleTalentoChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      talento_global: value || null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formMode === "create") {
      const result = await dispatch(createFraseThunk(formData));
      if (result.meta.requestStatus === "fulfilled") {
        const createdId = result.payload.data.id;
        dispatch(getFrasesThunk({ page: 1, search: "", talento: "", isRandom: "" }));
        toast.success('Frase creada exitosamente');
        // Abrir modal de vista con el nuevo registro
        await dispatch(getFraseByIdThunk(createdId));
        dispatch(openViewModal());
      }
    } else {
      const result = await dispatch(
        updateFraseThunk({
          id: selectedFrase.id,
          payload: formData,
        })
      );
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(getFrasesThunk({ page, search, talento: talentoFilter, isRandom: isRandomFilter }));
        toast.success('Frase actualizada exitosamente');
        // Abrir modal de vista con el registro actualizado
        await dispatch(getFraseByIdThunk(selectedFrase.id));
        dispatch(openViewModal());
      }
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title={formMode === "create" ? "Crear nueva frase" : "Editar frase"}
      size="lg"
    >
      {formLoading ? (
        <Loader
          center
          type="dots"
          text={
            formMode === "create"
              ? "Creando frase..."
              : "Actualizando frase..."
          }
        />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Frase <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="frase"
              value={formData.frase}
              onChange={handleChange}
              placeholder="Ingrese la frase"
              rows="4"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-medium">
              Talento asociado
            </label>
            <Select2
              value={formData.talento_global}
              onChange={handleTalentoChange}
              fetchOptions={fetchTalentos}
              placeholder="Selecciona un talento (opcional)"
              isClearable
            />
            <small className="text-muted">
              Si no seleccionas un talento, la frase no estará asociada a ninguno
            </small>
          </div>


          <div className="d-flex align-items-center justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-outline-secondary px-20 py-11"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary px-20 py-11">
              {formMode === "create" ? "Crear" : "Actualizar"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default FraseFormModal;
